module.exports = __webpack_public_path__ + "img/02.45d0ff89.png";